export default __webpack_public_path__ + "static/media/partner_img_06.80bc154b.svg";